require('/opt/odin/app/frontend/components/vertical_notice/index.module.scss');module.exports = "../../app/cells/components/vertical_notice/show.erb";